import { useEffect, useState } from 'react';
import { Box, Button, ButtonGroup, Checkbox, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { useUser } from '../../store/User';
import users from '../../data/users.json';
import './index.css';

const newUserFields = {
    "name": "text",
    "email": "email",
    "password": "password",
    "confirm password": "password"
};

const loginFields = {"email": "email", "password": "password"};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const Login = ({ viewModal }) => {
    const { setUser } = useUser();

    const [newUser, setNewUser] = useState(false);
    const [account, setAccount] = useState({});
    const [validLogin, setValidLogin] = useState(false);
    const [errorText, setErrorText] = useState(null);

    useEffect(() => {
        let fields = Object.keys(newUser ? newUserFields : loginFields);
        let accountObj = {};
        for(let field of fields) {
            accountObj[field] = '';
        }
        setAccount(accountObj);
        setValidLogin(false);
    }, [newUser]);

    const updateAccount = (field, value) => {
        let updatedAccount = { ...account };

        updatedAccount[field] = value;
        setAccount(updatedAccount);

        // Validate login info
        let valid = false;
        for(field of Object.keys(updatedAccount)) {
            if(field === "email") {
                valid = emailRegex.test(value);
            } else if (field === "confirm password") {
                valid = value === updatedAccount['password'] && value.length > 2;
            } else if (updatedAccount[field].length > 2) {
                valid = true;
            } else {
                valid = false;
                break;
            }
        }

        setValidLogin(valid);
    }

    const login = async() => {
        try {
            const userCreds = users.users.find(u => u.email === account.email && u.password === account.password);
            if(userCreds) {
                localStorage.setItem('terra-email', userCreds["email"]);
                localStorage.setItem('terra-password', userCreds["password"]);
                setUser(userCreds);
                closeAccount();
            } else {
                setErrorText("Invalid login credentials");
            }
        } catch (error) {
            console.error("Error fetching User:", error);
        }
    };

    const createAccount = async() => {
        try {
            const response = await fetch(`/api/user/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(account),
            });
            
            const result = await response.json();
            
            if("user" in result) {
                localStorage.setItem('terra-token', result["access_token"]);
                setUser(result["user"]);
                closeAccount();
            } else {
                setErrorText("Invalid login credentials");
            }
        } catch (error) {
            console.error("Error fetching User:", error);
        }
    }

    const closeAccount = () => {
        viewModal(false);
    }

    return (
        <Box component="form" 
            onSubmit={(e) => {
                e.preventDefault();
                newUser ? createAccount() : login();
            }} 
            className='modal-container'
        >
            {newUser ?
                <>
                    <Typography id="modal-modal-title" variant="h5" component="h2">
                        Create Account
                    </Typography>
                    <Grid container spacing={2}>
                        { Object.keys(newUserFields).map((field) => (
                        <Grid size={12} container spacing={1} key={`login-row-${field}`} sx={{ alignItems: "center"}}>
                            <TextField
                                key={`login-row-${field}-input`}
                                autoFocus={field === Object.keys(newUserFields)[0]}
                                label={field.toLocaleUpperCase()} 
                                sx={{ width: '100%' }} 
                                variant="outlined" 
                                size="small"
                                type={newUserFields[field]}
                                value={account[field] ? account[field] : ''}
                                onInput={(e) => updateAccount(field, e.target.value)}
                            />
                        </Grid>
                        ))}
                    </Grid>
                </>
            :
                <>
                    <Typography id="modal-modal-title" variant="h5" component="h2">
                        Login
                    </Typography>
                    <Grid container spacing={2}>
                        { Object.keys(loginFields).map((field) => (
                        <Grid size={12} container spacing={1} key={`login-row-${field}`} sx={{ alignItems: "center"}}>
                            <TextField
                                key={`login-row-${field}-input`}
                                autoFocus={field === Object.keys(loginFields)[0]}
                                label={field.toLocaleUpperCase()} 
                                sx={{ width: '100%' }} 
                                variant="outlined" 
                                size="small"
                                type={loginFields[field]}
                                value={account[field] ? account[field] : ''}
                                onInput={(e) => updateAccount(field, e.target.value)}
                                error={errorText !== null}
                                helperText={errorText}
                            />
                        </Grid>
                        ))}
                    </Grid>
                </>
            }

            <Grid container spacing={2} alignItems="center">
                <Grid size={6}>
                    <FormControlLabel id="new-account-check" control={<Checkbox checked={newUser} onChange={() => setNewUser(!newUser)} />} label="Create Account" />
                </Grid>
                <Grid size={6}>
                    <ButtonGroup size="small" sx={{ mt: 2, float: 'right' }}>
                        <Button type="submit" disabled={!validLogin}>
                            {newUser ? "CREATE ACCOUNT" : "LOGIN"}
                        </Button>
                        <Button onClick={() => closeAccount(false)}>
                            CLOSE
                        </Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
        </Box>
    );
}